import { Component } from '@angular/core';

@Component({
  selector: 'glxy-float-renderer',
  template: `
    @if (isNumber) {
      <div class="value">
        {{ value | number }}
      </div>
    } @else {
      @if (value) {
        <div class="value">
          {{ value }}
        </div>
      } @else {
        <glxy-blank-value />
      }
    }
  `,
  standalone: false,
})
export class FloatRendererComponent {
  isNumber = false;

  private _value: number | undefined;
  set value(val: number | undefined) {
    this._value = val;
    this.isNumber = typeof this._value === 'number';
  }
  get value(): number | undefined {
    return this._value;
  }
}
